import { render, staticRenderFns } from "./cardWriteoffDetail.vue?vue&type=template&id=fa61f200&scoped=true&"
import script from "./cardWriteoffDetail.vue?vue&type=script&lang=ts&"
export * from "./cardWriteoffDetail.vue?vue&type=script&lang=ts&"
import style1 from "./cardWriteoffDetail.vue?vue&type=style&index=1&id=fa61f200&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa61f200",
  null
  
)

export default component.exports